export var REQUEST_FEATURE_FLAGS_SUCCESS = "REQUEST_FEATURE_FLAGS_SUCCESS";
export var REQUEST_FEATURE_FLAGS_ERROR = "REQUEST_FEATURE_FLAGS_ERROR";
export var REQUEST_FEATURE_FLAGS = "REQUEST_FEATURE_FLAGS";
export function requestFeatureFlagsError(data) {
    return { type: REQUEST_FEATURE_FLAGS_ERROR, payload: data };
}
export function requestFeatureFlagsSuccess(data) {
    return {
        type: REQUEST_FEATURE_FLAGS_SUCCESS,
        payload: data,
    };
}
export function requestFeatureFlags() {
    return { type: REQUEST_FEATURE_FLAGS };
}
